import React, { useContext, useRef } from 'react'
// import IframeResizer from 'iframe-resizer-react'
// import { ThemeContext } from '../../contexts/ThemeContext'
import { ThemeContext } from 'styled-components'

// import { LanguageContext } from '../../contexts/Localisation/languageContext'
import { LanguageContext } from 'hooks/LanguageContext'

const Announcement: React.FC = () => {

  const height = window.innerHeight - 68

  const divHeight = window.innerHeight - 68

 const divStyle  =  {
    width:'100%',
    minHeight:`${divHeight}px`,
    marginTop:'-56px',
    marginBottom:'-56px'
    
 }

  const style = {width:'100%',border:'0px',minHeight:`${height}px`}
  

  const iframeRef = useRef(null)
  const { isDark } = useContext(ThemeContext)
  const { selectedLanguage } = useContext(LanguageContext)
  const sendSettings = (e) => {
    const payload = {
      isDark,
      selectedLanguage,
    }
    // iframeRef.current.sendMessage(payload)
  }
  return (
    <div style={divStyle}>
       <iframe title="Announcement" src="https://blog.csdn.net/qq_38519358/article/details/100667730" style={style}/>
    </div>
  )
}

export default Announcement
